module.exports = __webpack_public_path__ + "img/online_tvcc.da843036.svg";